import './App.css';
import * as cartActions from './Redux/Cart/CartActions';
import * as authActions from './Redux/Auth/AuthActions';
import { useDispatch } from 'react-redux';
import { Route, Routes } from 'react-router';
import Home from './Screens/Home-Screen/Home';
import Admin from './Screens/Admin-Screen/Admin';
import Guard, { AdminGuard, BlockAdminGuard } from './Routing/Guard';
import AccountScreen from './Screens/Account-screen/Account-screen';
import Login from './Screens/Login-Screen/Login';
import Store from './Redux';
import { Provider } from 'react-redux';
import { useEffect } from 'react';
import SignUp from './Screens/SignUp-Screen/SignUp';
import Editor from './Screens/Editor-Screen/Editor-screen';
import Landing from './Screens/Landing-screen/Landing';
import ResetPassword from './Screens/ResetPassword-Screen/ResetPassword';
import NotFound from './Screens/Error-Screen/NotFound-screen';
import ProductsScreen from './Screens/Products-screen/ProductsScreen';
import Product from './Screens/Products-screen/Product';
import Privacy from './Screens/Privacy-screen/Privacy';
import Terms from './Screens/Terms-screen/Terms';
import Shipping from './Screens/Shipping-screen/Shipping';
import Refund from './Screens/Refund-screen/Refund';
import Warranty from './Screens/Warranty-screen/Warranty';
import Success from './Screens/Success-screen/Success';
import ContactScreen from './Screens/Contact-screen/Contact-Screen';
import AboutScreen from './Screens/AboutUs-screren/About-screen';
import TermsHosting from './Screens/Terms-screen/TermsHosting';
import PaymentSuccess from './Screens/Success-screen/Payment-Success';
import OrderTracker from './Screens/Success-screen/OrderTracker';
import FlowmaQuiz from './Utils/Forms/ContactForm/FlowmaQuiz/flowma-quiz-form-component';
import OnBoardingForm from './Utils/Forms/OnBoardingForm/on-boarding-form-component';
import ThankYou from './Screens/ThankYou-screen/ThankYou';
import useLanguageParam from './Hooks/useLanguageParam';
import * as systemDataActions from './Redux/SystemData/systemDataActions';
import Project from './Screens/Projects-Screen/Project';
import Service from './Screens/Services-screen/Service';
import ServicesScreen from './Screens/Services-screen/Services-Screen';
import FlowmaBusinessScreen from './Screens/FlowmaBusiness-Screen/FlowmaBusinessScreen';
import PopUpPromotion from './Utils/Modal/pop-up-modal-component';
import Toast from './Utils/Toast/toast-component';
import ProductEditor from './Screens/Editor-Screen/Product-Editor-screen';
import AdminOrderDetail from './Screens/Admin-Screen/AdminOrderDetail';
import Location from './Screens/Locations-Screen/Location';
import LocationsScreen from './Screens/Locations-Screen/Locations-Screen';
import PromotionScreen from './Screens/Promotion-Screen/Promotion-Screen';
import OurWorkScreen from './Screens/OurWork-screen/OurWorkScreen';
import CommingSoon from './Screens/Error-Screen/ComingSoon-screen';
import PaymentFailed from './Screens/Error-Screen/PaymentFailed-screen';
import CartScreen from './Screens/Cart-screen/Cart-Screen';
import Products from './Screens/Products-screen/Products';
import CategoryScreen from './Screens/Category-screen/Category-screen';

function AppContent() {
  const dispatch = useDispatch();
  useLanguageParam();

  useEffect(() => {
    dispatch(authActions.isLoggedIn());
    dispatch(cartActions.fetchProducts());
    dispatch(systemDataActions.loadBannerMessages());
    dispatch(systemDataActions.loadBusinessInfo());
    dispatch(systemDataActions.loadLinks());
    dispatch(systemDataActions.loadCategories());
  }, [dispatch]);

  return (
    <>
      <div className="App font-primary">
        <Toast />
        <PopUpPromotion />
        <Routes>

          <Route path="/" element={<Landing />} />

          <Route path="/landing" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/resetpswd" element={<ResetPassword />} />
          <Route path="/signup" element={<SignUp />} />
 
          <Route path="/about" element={<AboutScreen />} />
          <Route path="/contact" element={<ContactScreen />} />
          <Route path="/promotion" element={<PromotionScreen />} />
          <Route path="/our-work" element={<OurWorkScreen />} />
 
          {/* <Route path="/porfolio" element={<WebsitesShowcase />} /> */}
 
          {/* <Route path="/projects/:projectSlug" element={<Project />} /> */}

          {/* <Route path="/locations/" element={<CommingSoon />} /> */}
          {/* <Route path="/locations/:locationSlug" element={<CommingSoon />} /> */}

          <Route path="/services" element={<ServicesScreen />} />
          <Route path="/services/:service" element={<Service />} />


          <Route path="/terms" element={<Terms />} />
          {/* <Route path="/terms-hosting" element={<TermsHosting />} /> */}

          <Route path="/privacy" element={<Privacy />} />
          <Route path="/shipping" element={<Shipping />} />
          <Route path="/refund-policy" element={<Refund />} />
          <Route path="/warranty" element={<Warranty />} />
          {/* <Route path="/form-success" element={<Success />} /> */}

          {/* <Route path="/on-boarding" element={<FlowmaQuiz />} /> */}
          {/* <Route path="/flowma-for-business" element={<FlowmaBusinessScreen />} /> */}
          {/* <Route path="/on-boarding-website" element={<OnBoardingForm />} /> */}

          {/* <Route path="/shop" element={<Landing />} /> */}
          {/* <Route path="/shop/:productId" element={<Product />} /> */}
          {/* <Route path="/categories/" element={<Products />} /> */}
          {/* <Route path="/categories/:slug" element={<CategoryScreen />} /> */}
          {/* <Route path="/cart" element={<CartScreen />} /> */}
          {/* <Route path="/payment-failed" element={<PaymentFailed />} /> */}

          <Route path="/thank-you" element={<ThankYou />} />
          <Route path='/*' element={<NotFound />} />


          {/* <Route path="/poll" element={<Poll />} /> */}
          <Route element={<BlockAdminGuard />}>
            <Route path="/success" element={<PaymentSuccess />} />
          </Route>
          <Route path="/track" element={<OrderTracker />} />


          {/* ── Admin-only routes ── */}
          <Route element={<AdminGuard />}>
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/order/:orderId" element={<AdminOrderDetail />} />
            <Route path="/locations/" element={<LocationsScreen />} />
            <Route path="/locations/:locationSlug" element={<Location />} />
            <Route path="/product-editor" element={<ProductEditor />} />
            <Route path="/system-editor/:Field" element={<Editor />} />
          </Route>

          {/* ── Customer-only routes ── */}
          <Route element={<Guard />}>
            <Route path="/home" element={<Home />} />
            <Route path="/account" element={<AccountScreen />} />
          </Route>
        </Routes>
      </div >
    </>
  );
}

function App() {
  useEffect(() => {
    // window.Cookiebot.show();

  }, []);

  return (
    <Provider store={Store}>
      <AppContent />
    </Provider>
  );
}

export default App;
